// AUTO-GENERATED by scripts/gen-build-info.js — do not edit.
export const BUILD_INFO = { sha: 'd31e6b5b', builtAt: '2026-10-26 15:27 UTC' };
